import { useTranslation } from "react-i18next";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { ModelsSelect } from "../../../Components/Selects/Components/ModelSelects";
import styles from "./styles.module.css";
import { TModelItem } from "../../../../services/api/instances/modelsApi/types";

interface Props {
  modelId: string;
  updateObject: (model: TModelItem | null) => void;
}

export const ChatModelsSelection = ({ ...props }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <AppLabel>{t("chat_modal.select_model")}</AppLabel>
      <ModelsSelect modelId={props.modelId} updateObject={props.updateObject} />
    </div>
  );
};
